import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { menuIdForPath } from "../lib/menus";

export const ProtectedRoute = ({ children, perm }) => {
  const { user, ready, can, menuAllowed } = useAuth();
  const location = useLocation();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="auth-loading">Memuat sesi...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if ((perm && !can(perm)) || !menuAllowed(menuIdForPath(location.pathname))) {
    return (
      <div className="max-w-md mx-auto mt-16 text-center space-y-2" data-testid="forbidden-page">
        <h1 className="text-2xl font-bold text-slate-900">Akses Ditolak</h1>
        <p className="text-sm text-slate-500">Role Anda tidak memiliki izin untuk membuka halaman ini.</p>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
